import React from 'react'
import './index.css'
const HeadingBlock = ({text}) => {
  return (
    <h3>{text}</h3>
  )
}

export default HeadingBlock